module.exports = __webpack_public_path__ + "static/media/55_000040.2f349dd4.jpg";